export const checkoutBG = {
  "less255": "Максимум 255 символа",
  "less50": "Максимум 50 символа",
  "less20": "Максимум 20 символа",
  "less10": "Максимум 10 символа",
  "required": "Задължително",
  "invalidEmail": "Невалиден имейл",
  "invalidPhone": "Невалиден номер",
  "textareaMax": "Максимум 1000 символа",
  "invalidPayment": "Невалиден начин на плащане",
  "terms": "Трябва да приемете общите условия",
  "createAccount": "Създаване на акаунт",
  "differentDeliveryAddress": "Доставка на друг адрес",
  "orderComments": "Коментари към поръчката",
  "payment": "ПЛАЩАНЕ",
  "cash": "Плащане при доставка",
  "cashInShop": "Плащане в магазина",
  "cashText": "Плащане в брой при получаване на стоката",
  "clickAway": "Pick up",
  "clickAwayText": "Взимане на стоката от магазина",
  "paypalRadio": "Кредитна карта или PayPal",
  "vivaRadio": "Кредитна карта или Viva",
  "creditCard": "Кредитна карта",
  "paypalError": "Моля, попълнете формуляра правилно!",
  "personalDataInfo": "Вашите лични данни ще бъдат използвани за целите на този сайт и за управлението на вашия акаунт.",
  "readThe": "Прочетете",
  "iHaveRead": "Прочетох и съм съгласен с",
  "ofThisSite": "на този сайт",
  "yourOrder": "Вашата поръчка",
  "sendOrder": "Изпрати поръчка",
  "alreadyCustomer": "Вече съм клиент",
  "orderCompleteTitle": "ПОРЪЧКАТА Е ЗАВЪРШЕНА!",
  "orderCompleteLine1": "Вашата поръчка е получена успешно.",
  "orderCompleteLine2": "Благодарим ви за вашата поръчка.",
  "isCompany": "Издаване на фактура",
  "companyAfm": "ДДС номер",
  "companyDoy": "Данъчна служба",
  "companyName": "Име на фирмата",
  "companyProfession": "Професия",
  "bankTransfer": "Банков превод",
  "bankTransferText": "Превод към една от нашите банкови сметки.",
  "bankLargeText": "Направете плащането директно в нашата банкова сметка. Моля, включете номера на вашата поръчка в банковия превод. Вашата поръчка ще бъде изпратена след потвърждение на превода.",
  "bank": "Банка",
  "nbgRadio": "Кредитна карта през БНБ",
  "without": "Без",
  "checkoutData": "Данни за плащане",
  "product": "ПРОДУКТ",
  "subTotal": "МЕЖДИННА СУМА",
  "without": "БЕЗ",
  "total": "ОБЩО",
  "doYouHave": "Вече имате акаунт? Кликнете ",
  "here": "тук",
  "toConnect": ", за да се свържете.",
  "legalName": "Официално име",
  "legalDescription": "Тип на фирмата",
  "postalAddress": "Основна улица",
  "postalAddressNo": "Номер",
  "postalAreaDescription": "Основен град",
  "postalZipCode": "Пощенски код",
  "firmActDescription": "Основна дейност",
  "companyPhone": "Телефон",
  "companyEmail": "Имейл",
  "doyDescription": "Име на данъчната служба",
  "returnToShop": "ОБРАТНО В МАГАЗИНА",
  "alergies": "Имате ли алергия или непоносимост към някаква храна? Имате ли някакви хранителни ограничения? Свържете се с магазина преди да направите поръчка.",
  "proceedToPayment": "ПРОДЪЛЖИ КЪМ ПЛАЩАНЕ",
  "allowRecurring": "Повтарящо се плащане",
  "subscriptionInterval": "Интервал между плащанията в месеци",
  "delivery": "Доставка",
  "orderKind": "Начин на получаване",
  "scheduleForLater": "Планирайте за по-късно",
  "scheduledDeliveryTime": "Час на доставка",
  "scheduledPickupTime": "Час на вземане",
  "fillAllFields": "Моля, попълнете всички задължителни полета.",
  "invalidTotal": "Невалидна обща сума на поръчката. Моля, прегледайте количката си.",
  "paymentError": "Плащането е неуспешно. Моля, опитайте отново.",
  invalidVat: "Invalid VAT number",
  pickupNoAddress: "Вземане от магазина — не е необходим адрес за доставка.",
}